import React, {useCallback} from 'react'

export const fadeThreshold = 50

export const useRefreshFade = (
  ref: React.RefObject<HTMLElement>,
  innerRef: React.RefObject<HTMLElement>
): (() => void) =>
  useCallback(() => {
    if (ref.current && innerRef.current) {
      // Safari before 16 v. has problems w/ mask combination
      if (
        window.platform?.name === 'Safari' &&
        window.platform?.version &&
        window.platform?.version < '16.0'
      ) {
        return
      }

      const {width} = ref.current.getBoundingClientRect()
      const {width: innerWidth} = innerRef.current.getBoundingClientRect()

      const offsetLeft = ref.current.scrollLeft
      const opacityLeft =
        1 - Math.max(Math.min(offsetLeft / fadeThreshold, 1), 0)
      const maskLeft = `linear-gradient(90deg, rgba(0, 0, 0, ${opacityLeft}) 0%, black 34px)`

      const offsetRight = innerWidth - offsetLeft - width
      const opacityRight =
        1 - Math.max(Math.min(offsetRight / fadeThreshold, 1), 0)
      const maskRight = `linear-gradient(270deg, rgba(0, 0, 0, ${opacityRight}) 0%, black 34px)`

      const mask = `${maskLeft}, ${maskRight}`
      ref.current.style.maskImage = mask
      ref.current.style.webkitMaskImage = mask
      ref.current.style.maskComposite = 'destination-in'
      ref.current.style.webkitMaskComposite = 'destination-in'
    }
  }, [ref, innerRef])
